import { render } from "./new-account-vantage.vue?vue&type=template&id=383186d3"
import script from "./new-account-vantage.js?vue&type=script&lang=js&external"
export * from "./new-account-vantage.js?vue&type=script&lang=js&external"

import "./new-account-vantage.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__